import dayjs from 'dayjs';
import { isEqual } from 'lodash-es';
import { AppointmentAnalyticsTypes } from '@frontend/api-analytics';
import { createShallowStore, createStoreWithSubscribe } from '@frontend/store';

interface AppointmentAnalyticsStore {
  defaultFilters: AppointmentAnalyticsTypes.Filters;
  filterHintText: string;
  filters: AppointmentAnalyticsTypes.Filters;
  hasCustomFilters: boolean;
  locationId: string;

  setDefaultFilters: (defaultFilters: Partial<AppointmentAnalyticsTypes.Filters>) => void;
  setFilterHintText: (filterHintText: string) => void;
  setFilters: (filters: Partial<AppointmentAnalyticsTypes.Filters>) => void;
  setLocationId: (locationId: string) => void;
}

const useAppointmentAnalyticsStore = createStoreWithSubscribe<AppointmentAnalyticsStore>(
  (set, get) => ({
    defaultFilters: {},
    filterHintText: '',
    filters: {},
    hasCustomFilters: false,
    locationId: '',

    setDefaultFilters: (defaultFilters) => {
      set({ defaultFilters });
    },
    setFilterHintText: (filterHintText) => {
      set({ filterHintText });
    },
    setFilters: (filters) => {
      const { defaultFilters = {}, filters: currentFilters } = get();
      const newFilters: AppointmentAnalyticsTypes.Filters = { ...currentFilters, ...filters };

      const { StartDate: defaultStartDate, EndDate: defaultEndDate, ...otherDefaults } = defaultFilters;

      const areDatesEqual =
        dayjs(newFilters.StartDate).isSame(dayjs(defaultStartDate), 'date') &&
        dayjs(newFilters.EndDate).isSame(dayjs(defaultEndDate), 'date');

      set({
        filters: newFilters,
        hasCustomFilters:
          !areDatesEqual ||
          Object.keys(otherDefaults).some(
            (key) =>
              !isEqual(
                newFilters[key as keyof AppointmentAnalyticsTypes.Filters],
                defaultFilters[key as keyof AppointmentAnalyticsTypes.Filters]
              )
          ),
      });
    },
    setLocationId: (locationId) => {
      set({ locationId });
    },
  }),
  {
    name: 'AppointmentAnalyticsStore',
    trace: true,
  }
);

export const useAppointmentAnalyticsShallowStore =
  createShallowStore<AppointmentAnalyticsStore>(useAppointmentAnalyticsStore);
